export function capitalize (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function labelCase (str) {
  str = str.replace(/_/g, ' ')
  return capitalize(str)
}

export function lowerCase (str) {
  return str.toLowerCase()
}

export function upperCase (str) {
  return str.toUpperCase()
}

export function unCamelCase (str) {
  str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2')
  str = str.toLowerCase()
  return str
}

export function properCase (str) {
  return lowerCase(str).replace(/^\w|\s\w/g, upperCase)
}

export function removeNonWord (str) {
  return str.replace(/[^0-9a-zA-Z\xC0-\xFF -]/g, '')
}

export function pad (num, size) {
  var s = num + ''
  while (s.length < size) s = s + '0'
  return s
}



// WEBPACK FOOTER //
// ./src/filters/string.js